import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import { PASearch } from "../PA.Core/PASearch";
import { SearchUtils } from "../PA.UIM.Core/SearchUtils";
import { PAEnvironment } from "../PA.Core/PAEnvironment";

var vUI_CircularConfig_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_CIRCULARCONFIG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: "Id", columnResourceName: "colId", alignment: HorizAlignment.Center },
        domainOptions: {}
    },
    CONFIG_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Circular Config Id",
            columnResourceName: "colCircularConfigId",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    CONFIG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Circular Config Name",
            columnResourceName: "colName",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "Created Date",
            columnResourceName: "colCreateDt",
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "Modified Date",
            columnResourceName: "colModifiedDt",
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: "MDSetId", columnResourceName: "colMDSetId", alignment: HorizAlignment.Center },
        domainOptions: {}
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "SalesOrgId",
            columnResourceName: "colSalesOrgId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    MDSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Master Data Set",
            columnResourceName: "colSetName",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    SALESORG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Sales Org",
            columnResourceName: "colSalesOrgName",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    }
};

var CircularConfigSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: "WB_CIRCULARCONFIG_ID",
        id_ui: "CONFIG_ID",
        name: "CONFIG_NAME"
    },

    searchProviderFields: vUI_CircularConfig_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                "vUI_CircularConfig_Search",
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res);
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

};


var CircularConfigSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "CircularConfigSearchProfileByName" },

    profileFilter: [
        { profileFilterName: "Id", searchProviderFieldId: "CONFIG_ID", renderOptions: {} },
        { profileFilterName: "Name", searchProviderFieldId: "CONFIG_NAME", renderOptions: {} }
    ],  // ISearchFields
    profileDisplayFields: [
        "CONFIG_ID", "CONFIG_NAME", "MDSET_NAME", "SALESORG_NAME", "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CircularConfigSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};


var CircularConfigSearch: ISearch = {
    searchName: "Find Circular Config",
    renderOptions: { ui5ResourceId: "CircularConfigSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: [CircularConfigSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("CircularConfigBO", "CircularConfig", CircularConfigSearch, "Circular Config Search");

export { CircularConfigSearch };